import PageLayoutDefault from '@leuven2030/food/Page/PageLayoutDefault';

const PageFallback = () => {
  return (
    <PageLayoutDefault>
      <div tw="flex justify-center items-start w-full">Loading</div>
    </PageLayoutDefault>
  );
};

export default PageFallback;
